<template>
  <UiBaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="icon"
  >
    <path
      d="M13.7321 12.3182H12.9907L12.7279 12.065C13.8541 10.7518 14.436 8.96032 14.1169 7.05624C13.6758 4.44869 11.4984 2.36639 8.87055 2.04749C4.90061 1.55974 1.55948 4.89891 2.04751 8.86652C2.36661 11.4928 4.45012 13.6689 7.05921 14.1098C8.9644 14.4287 10.757 13.8471 12.0709 12.7216L12.3243 12.9842V13.7252L16.313 17.7116C16.6978 18.0961 17.3266 18.0961 17.7114 17.7116C18.0962 17.327 18.0962 16.6986 17.7114 16.314L13.7321 12.3182ZM8.10096 12.3182C5.76405 12.3182 3.87763 10.4329 3.87763 8.09739C3.87763 5.76184 5.76405 3.87653 8.10096 3.87653C10.4379 3.87653 12.3243 5.76184 12.3243 8.09739C12.3243 10.4329 10.4379 12.3182 8.10096 12.3182Z"
      fill="#2B3A49"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>

<style scoped lang="scss"></style>
